import isEmpty from 'lodash.isempty';

const useRole = () => {
    const role = {
        authenticated: 'authenticated',
        anonymous: 'anonymous'
    };

    const rolemap = [
        { approle: role.anonymous, externalRole: 'link' }, // Authentication not needed
        { approle: role.anonymous, externalRole: 'auth_link' }, // Authentication always needed
        { approle: role.anonymous, externalRole: 'check_auth_link' }, // Authentication maybe needed
        { approle: role.authenticated, externalRole: 'tupas' },
        { approle: role.anonymous, externalRole: 'userpool' }
    ];

    /**
     * Function to get role by external role.
     * @param {string} role
     * @returns {string}
     */
    const getRole = (role) => {
        const item = rolemap.find(e => e.externalRole === role);
        return item.approle;
    }

    /**
     * Function to check user is authorized by role.
     * @param externalRoles
     * @returns {string[]}
     */
    const roleSolver = (externalRoles) => {
        const roles = [];

        // Return empty roles array if External roles are empty or is not array
        if (isEmpty(externalRoles) || !Array.isArray(externalRoles)) {
            return roles;
        }

        externalRoles.forEach((item) => {
            const approle = getRole(item);
            if (!isEmpty(approle)) {
                roles.push(approle);
            }
        });

        return roles;
    }

    return {
        role,
        roleSolver
    };
}

export default useRole;
